/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { HotTable, HotTableClass } from '@handsontable/react'
import Handsontable from 'handsontable'
import { registerAllModules } from 'handsontable/registry'

import 'handsontable/styles/handsontable.css'
import 'handsontable/styles/ht-theme-main.css'

import { XLSX, buildCorporateSheet } from '../../utils/excelCorporateStyle'
import {
  Button,
  ButtonClose,
  Content,
  DateInput,
  Label,
  LeftContent,
  Right,
  Spinner,
} from './styles'
import Select from 'react-select'
import { CamposOrdenaveis } from '../../hooks/dndComponents'
import {
  formatCaixa,
  formatCpfCnpj,
  formatCurrencyBr,
  formatCurrencyBrr,
  formatDateBr,
  formatUnidade,
  getRegional,
  loadDistribuidores,
} from '../../constantes'
import { FieldOption, RelatorioVendasProps } from '../../Interfaces'
import { toast } from 'react-toastify'
import api from '../../services/axios'
import { gerarApresentacao } from '../../services/gerarApresentacao'
import { SelectionModal, SelectionItem } from './SelectionModal'
import { FaBuilding, FaBoxes, FaChevronRight, FaTag } from 'react-icons/fa'
import { carregarMarcas, MarcaItem } from '../../services/marcas'
import { carregarFamilias, FamiliaItem } from '../../services/familias'
import AbaRelatorioSemanalTemp from './AbaRelatorioSemanalTemp'
const TabButton = ({ active, onClick, children }: any) => (
  <button
    onClick={onClick}
    style={{
      padding: '10px 20px',
      border: 'none',
      borderRadius: '8px',
      background: active ? '#3b82f6' : 'rgba(255, 255, 255, 0.05)',
      fontWeight: '600',
      cursor: 'pointer',
      color: active ? '#ffffff' : '#94a3b8',
      fontSize: '14px',
      transition: 'all 0.2s ease-in-out',
      boxShadow: active ? '0 2px 4px rgba(59, 130, 246, 0.4)' : 'none',
    }}
    onMouseEnter={(e) => {
      if (!active) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
    }}
    onMouseLeave={(e) => {
      if (!active) e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
    }}
  >
    {children}
  </button>
)

registerAllModules()

export default function RelatorioVendas() {
  const hotRef = useRef<HotTableClass>(null)

  const [tab, setTab] = useState<
    'vendas' | 'estoque' | 'cobertura' | 'cobertura_clientes' | 'invalidos' | 'apresentacao' | 'semanal_temp'
  >('vendas')

  const [selectedDistribuidores, setSelectedDistribuidores] = useState<any[]>([])
  const [showDistModal, setShowDistModal] = useState(false)
  const [selectedMarcas, setSelectedMarcas] = useState<any[]>([])
  const [showMarcaModal, setShowMarcaModal] = useState(false)
  const [showFamiliaModal, setShowFamiliaModal] = useState(false)
  const [distribuidores, setDistribuidores] = useState<any[]>([])
  const [marcas, setMarcas] = useState<MarcaItem[]>([])
  const [familias, setFamilias] = useState<FamiliaItem[]>([])
  const [loading, setLoading] = useState(false)
  const [apresentacaoGerada, setApresentacaoGerada] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [selectedFamilias, setSelectedFamilias] = useState<any[]>([])

  const [dadosVendasAPI, setDadosVendasAPI] = useState<any[]>([])
  const [dadosEstoqueAPI, setDadosEstoqueAPI] = useState<any[]>([])
  const [dadosCoberturaAPI, setDadosCoberturaAPI] = useState<any[]>([])
  const [dadosCoberturaClientesAPI, setDadosCoberturaClientesAPI] = useState<any[]>([])
  const [dadosInvalidosAPI, setDadosInvalidosAPI] = useState<any[]>([])
  const [dadosApresentacaoAPI, setDadosApresentacaoAPI] = useState<any[]>([])

  const [fields, setFields] = useState<FieldOption[]>([
    { key: 'cod_dist', label: 'Cod Dist', table: 'sellout', visible: false, type: 'check' },
    { key: 'cnpj', label: 'Cnpj Distribuidor', table: 'sellout', visible: false, type: 'check' },
    { key: 'distribuidor', label: 'Distribuidor', table: 'sellout', visible: true, type: 'check' },
    { key: 'nm_client', label: 'Nome Cliente', table: 'clientes', visible: true, type: 'check' },
    { key: 'city', label: 'Cidades', table: 'clientes', visible: true, type: 'check' },
    { key: 'cod_cat', label: 'Codigo categoria', table: 'interno', visible: true, type: 'check' },
    { key: 'familia', label: 'Família', table: 'interno', visible: true, type: 'check' },
    { key: 'descricao', label: 'Descrição', table: 'interno', visible: true, type: 'check' },
    { key: 'data', label: 'Data de Venda', table: 'sellout', visible: true, type: 'date-range' },
    { key: 'semana', label: 'Semana', table: 'sellout', visible: true, type: 'check' },
    { key: 'valor_dist', label: 'Valor Dist', table: 'sellout', visible: false, type: 'check' },
    {
      key: 'qnt_cx',
      label: 'Quantidade em caixas',
      table: 'sellout',
      visible: true,
      type: 'check',
    },
    { key: 'cobertura', label: 'Cobertura', table: 'sellout', visible: true, type: 'check' },
    { key: 'valor_gsa', label: 'Valor GSA', table: 'sellout', visible: true, type: 'check' },
    { key: 'qnt', label: 'Quantidade em unidade', table: 'sellout', visible: false, type: 'check' },
    { key: 'valor', label: 'Valor', table: 'sellout', visible: false, type: 'check' },
    { key: 'media', label: 'Media', table: 'sellout', visible: true, type: 'check' },
    { key: 'uf', label: 'UF', table: 'clientes', visible: false, type: 'check' },
    { key: 'regional', label: 'Regional', table: 'clientes', visible: true, type: 'check' },
    { key: 'sku', label: 'SKU', table: 'interno', visible: true, type: 'check' },
    { key: 'marca', label: 'Marca', table: 'interno', visible: true, type: 'check' },
    { key: 'status', label: 'Ativo?', table: 'interno', visible: true, type: 'check' },
    {
      key: 'cnpj_cpf_pdv',
      label: 'CNPJ Cliente',
      table: 'clientes',
      visible: false,
      type: 'check',
    },
    { key: 'tipo_venda', label: 'Tipo de venda', table: 'sellout', visible: false, type: 'select' },
    { key: 'ean', label: 'EAN (Venda)', table: 'sellout', visible: false, type: 'check' },
    {
      key: 'cod_representante',
      label: 'Representante código host',
      table: 'cobertura',
      visible: false,
      type: 'check',
    },
    {
      key: 'total_cober',
      label: 'Qtd Clientes',
      table: 'cobertura',
      visible: false,
      type: 'check',
    },
    {
      key: 'representante',
      label: 'Representante',
      table: 'cobertura',
      visible: false,
      type: 'check',
    },
    { key: 'qt', label: 'Estoque (Unid)', table: 'estoque', visible: false, type: 'check' },
    {
      key: 'dt_ref',
      label: 'Data Referência',
      table: 'estoque',
      visible: false,
      type: 'date-range',
    },
    {
      key: 'produto_info',
      label: 'EAN Informado (Estoque)',
      table: 'estoque',
      visible: false,
      type: 'check',
    },
    {
      key: 'info_produto',
      label: 'Informação do produto',
      table: 'invalidos',
      visible: false,
      type: 'check',
    },
    {
      key: 'rz_fornecedor',
      label: 'Razão Social',
      table: 'invalidos',
      visible: false,
      type: 'check',
    },
    {
      key: 'total_cobertura_cliente',
      label: 'Total Cobertura (Qtd Clientes)',
      table: 'cobertura_clientes',
      visible: false,
      type: 'check',
    },
    { key: 'ap_categoria', label: 'Categoria', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_sellout_ma', label: 'Sellout (MA)', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_sellout_atual', label: 'Sellout (Atual)', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_gap_mxm', label: 'GAP MxM (Sellout)', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_gap_pct', label: 'GAP MA (%)', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_cob_ma', label: 'Cobertura (MA)', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_cob_atual', label: 'Cobertura (Atual)', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_gap_cob', label: 'GAP Cob', table: 'apresentacao', visible: false, type: 'check' },
    { key: 'ap_meta', label: 'Meta', table: 'apresentacao', visible: false, type: 'check' },
  ])

  const [selectedFields, setSelectedFields] = useState<string[]>(
    fields.filter((f) => f.visible).map((f) => f.key),
  )

  useEffect(() => {
    loadDistribuidores({ setDistribuidores })
    carregarMarcas().then((res) => setMarcas(res))
    carregarFamilias().then((res) => setFamilias(res))
  }, [])

  const carregarRelatorio = async () => {
    if (tab !== 'cobertura_clientes' && tab !== 'invalidos' && (!startDate || !endDate)) {
      if (tab !== 'estoque') {
        toast.warn('Selecione o período completo.')
        return
      }
    }

    setLoading(true)
    try {
      const isTodosDist =
        selectedDistribuidores.length === 0 ||
        selectedDistribuidores.some((d) => d.value === 'todos')

      const distIds = isTodosDist
        ? []
        : selectedDistribuidores
            .map((d) => Number(d.value))
            .filter((n) => !isNaN(n) && n > 0)

      const isTodasMarcas =
        selectedMarcas.length === 0 ||
        selectedMarcas.some((m) => m.value === 'todas')

      const marcasFiltradas = isTodasMarcas
        ? []
        : selectedMarcas
            .map((m) => String(m.value))
            .filter((m) => m && m !== 'todas' && m !== '__NONE__')

      const isTodasFamilias =
        selectedFamilias.length === 0 ||
        selectedFamilias.some((f) => f.value === 'todas')

      const familiasFiltradas = isTodasFamilias
        ? []
        : selectedFamilias
            .map((f) => String(f.value))
            .filter((f) => f && f !== 'todas' && f !== '__NONE__')

      const payload = {
        distId: isTodosDist ? 'todos' : (distIds.length === 1 ? distIds[0] : distIds),
        distIds,
        startDate,
        endDate,
        familias: familiasFiltradas,
        marcas: marcasFiltradas,
      }

      if (tab === 'apresentacao') {
        const [yearStr, monthStr] = startDate ? startDate.split('-') : [new Date().getFullYear().toString(), (new Date().getMonth() + 1).toString()]
        setApresentacaoGerada(false)
        
        // Timeout longo para garantir que o render do loading apareça antes de travar a thread
        setTimeout(async () => {
          try {
            await gerarApresentacao({
              operacao: '',
              gestor: '',
              categoria: '',
              marca: marcasFiltradas.join(','),
              year: parseInt(yearStr),
              month: parseInt(monthStr),
              startDate,
              endDate,
              distId: isTodosDist ? 'todos' : (distIds.length === 1 ? distIds[0] : null),
              distIds,
            })
            toast.success('Apresentação gerada com sucesso!');
            setApresentacaoGerada(true);
          } catch (e) {
            console.error('ERRO DETALHADO PPTX:', e);
            toast.error('Erro ao gerar apresentação.');
          } finally {
            setLoading(false)
          }
        }, 500);
        return
      }

      let rota = ''
      if (tab === 'vendas') rota = '/get/vendas'
      else if (tab === 'estoque') rota = '/get/relatorio/estoque'
      else if (tab === 'cobertura') rota = '/get/relatorio/cobertura'
      else if (tab === 'cobertura_clientes') rota = '/get/relatorio/cobertura-clientes'
      else if (tab === 'invalidos') rota = '/get/relatorio/invalidos'

      const res = await api.post(rota, payload)
      const dataBackend = res.data?.data ?? res.data ?? []

      if (tab === 'vendas') {
        const dadosFormatados = dataBackend.map((row: any) => ({
          ...row,
          _raw_qnt: Number(row.qnt || 0),
          _raw_qnt_cx: Number(row.qnt_cx || 0),
          _raw_valor_dist: Number(row.valor_dist || 0),
          cnpj: formatCpfCnpj(row.cnpj_cpf_pdv || row.cnpj || ''),
          regional: row.regional || getRegional(String(row.uf || '')),
          valor: formatCurrencyBrr(Number(row.valor || 0)),
          qnt: formatUnidade(Number(row.qnt || 0)),
          qnt_cx: formatCaixa(Number(row.qnt_cx || 0)),
          valor_dist: formatCurrencyBrr(Number(row.valor_dist || 0)),
          data: formatDateBr(row.data),
        }))
        setDadosVendasAPI(dadosFormatados)
      } else if (tab === 'estoque') {
        const dadosFormatados = dataBackend.map((row: any) => ({
          ...row,
          _raw_qt: Number(row.qt || 0),
          _raw_qnt_cx: Number(row.qnt_cx || 0),
          dt_ref: formatDateBr(row.dt_ref),
          qnt_cx: formatCaixa(Number(row.qnt_cx || 0)),
          qt: formatUnidade(Number(row.qt || 0)),
        }))
        setDadosEstoqueAPI(dadosFormatados)
      } else if (tab === 'cobertura') {
        setDadosCoberturaAPI(dataBackend)
      } else if (tab === 'cobertura_clientes') {
        setDadosCoberturaClientesAPI(dataBackend)
      } else if (tab === 'invalidos') {
        const dadosFormatados = dataBackend.map((row: any) => ({
          ...row,
          data: formatDateBr(row.data),
          qnt: formatUnidade(Number(row.qnt || 0)),
          valor: formatCurrencyBr(Number(row.valor || 0)),
          nm_client: row.nm_client || '',
          regional: row.regional || getRegional(String(row.uf || '')),
          ean: row.ean || row.produto || '',
        }))
        setDadosInvalidosAPI(dadosFormatados)
      }

      if (dataBackend.length === 0) toast.info('Nenhum dado encontrado para os filtros.')
      setLoading(false)
    } catch (e) {
      console.error('Erro ao carregar relatório:', e)
      toast.error('Erro ao carregar os dados do relatório.')
      setLoading(false)
    }
  }

  useEffect(() => {
    setDadosVendasAPI([])
    setDadosEstoqueAPI([])
    setDadosCoberturaAPI([])
    setDadosCoberturaClientesAPI([])
    setDadosInvalidosAPI([])
    setDadosApresentacaoAPI([])

    let activeKeys: string[] = []

    if (tab === 'vendas') {
      activeKeys = [
        'cod_dist',
        'distribuidor',
        'nm_client',
        'city',
        'cod_cat',
        'familia',
        'sku',
        'descricao',
        'data',
        'semana',
        'valor_dist',
        'qnt_cx',
        'cobertura',
        'valor_gsa',
        'qnt',
        'valor',
        'media',
        'uf',
      ]
    } else if (tab === 'cobertura') {
      activeKeys = [
        'cod_representante',
        'representante',
        'cod_cat',
        'familia',
        'total_cober',
      ]
    } else if (tab === 'estoque') {
      activeKeys = [
        'cod_dist',
        'distribuidor',
        'cod_cat',
        'familia',
        'dt_ref',
        'semana',
        'qnt_cx',
        'qt',
      ]
    } else if (tab === 'invalidos') {
      activeKeys = [
        'cod_dist',
        'distribuidor',
        'ean',
        'info_produto',
        'rz_fornecedor',
        'data',
        'tipo_venda',
        'qnt',
        'valor',
      ]
    } else if (tab === 'cobertura_clientes') {
      activeKeys = ['cod_dist', 'distribuidor', 'total_cobertura_cliente']
    } else if (tab === 'apresentacao') {
      activeKeys = [
        'ap_categoria',
        'ap_sellout_ma',
        'ap_sellout_atual',
        'ap_gap_mxm',
        'ap_gap_pct',
        'ap_cob_ma',
        'ap_cob_atual',
        'ap_gap_cob',
        'ap_meta',
      ]
    }

    setSelectedFields(activeKeys)

    setFields((prevFields) =>
      prevFields.map((f) => ({
        ...f,
        visible: activeKeys.includes(f.key),
      })),
    )
  }, [tab])

  const nomeDistribuidor = useMemo(() => {
    if (selectedDistribuidores.length === 0 || selectedDistribuidores.some((d) => d.value === 'todos')) {
      return 'Todos os Distribuidores'
    }
    if (selectedDistribuidores.length === 1) {
      return String(selectedDistribuidores[0].label || '').split(' - ')[0]
    }
    return `${selectedDistribuidores.length} Distribuidores`
  }, [selectedDistribuidores])

  const distItems: SelectionItem[] = useMemo(() => {
    return distribuidores.map((d) => ({
      id: d.id,
      label: d.fantasy_name || d.name || `Distribuidor ${d.id}`,
      subtitle: d.cnpj ? formatCpfCnpj(d.cnpj) : undefined,
      extra: d.cod_dist ? `Cód: ${d.cod_dist}` : (d.regional ? `Reg: ${d.regional}` : undefined),
    }))
  }, [distribuidores])

  const selectedDistIds = useMemo(() => {
    return selectedDistribuidores.map((d) => d.value)
  }, [selectedDistribuidores])

  const marcaItems: SelectionItem[] = useMemo(() => {
    return marcas.map((m) => ({
      id: m.marca,
      label: m.rotulo || m.marca,
      subtitle: m.categorias?.length ? m.categorias.slice(0, 2).join(', ') : undefined,
    }))
  }, [marcas])

  const selectedMarcaIds = useMemo(() => {
    return selectedMarcas.map((m) => m.value)
  }, [selectedMarcas])

  const handleConfirmMarcas = (newIds: (string | number)[]) => {
    if (newIds.length === 0) {
      setSelectedMarcas([])
    } else if (newIds.includes('__NONE__')) {
      setSelectedMarcas([{ value: '__NONE__', label: 'Nenhuma' }])
    } else {
      const newSelected = newIds.map((id) => ({ value: String(id), label: String(id) }))
      setSelectedMarcas(newSelected)
    }
  }

  const familiaItems: SelectionItem[] = useMemo(() => {
    const selectedMarcaNomes = selectedMarcas
      .filter((m) => m.value && m.value !== 'todas' && m.value !== '__NONE__')
      .map((m) => String(m.value).toUpperCase())

    let list = familias
    if (selectedMarcaNomes.length > 0) {
      const filtradas = familias.filter((f) =>
        f.marcas?.some((m) => selectedMarcaNomes.includes(m.toUpperCase()))
      )
      if (filtradas.length > 0) {
        list = filtradas
      }
    }

    return list.map((f) => ({
      id: f.familia,
      label: f.rotulo || f.familia,
      subtitle: f.marcas?.length ? f.marcas.join(', ') : undefined,
    }))
  }, [familias, selectedMarcas])

  const selectedFamiliaIds = useMemo(() => {
    return selectedFamilias.map((f) => f.value)
  }, [selectedFamilias])

  const handleConfirmDistribuidores = (newIds: (string | number)[]) => {
    if (newIds.length === 0) {
      setSelectedDistribuidores([])
    } else if (newIds.includes('__NONE__')) {
      setSelectedDistribuidores([{ value: '__NONE__', label: 'Nenhum' }])
    } else {
      const newSelected = distItems
        .filter((item) => newIds.some((id) => String(id) === String(item.id)))
        .map((item) => ({ value: item.id, label: `${item.label} - ${item.subtitle || ''}` }))
      setSelectedDistribuidores(newSelected)
    }
    setDadosVendasAPI([])
    setDadosEstoqueAPI([])
    setDadosCoberturaAPI([])
    setDadosCoberturaClientesAPI([])
    setDadosInvalidosAPI([])
    setDadosApresentacaoAPI([])
  }

  const handleConfirmFamilias = (newIds: (string | number)[]) => {
    if (newIds.length === 0) {
      setSelectedFamilias([])
    } else if (newIds.includes('__NONE__')) {
      setSelectedFamilias([{ value: '__NONE__', label: 'Nenhuma' }])
    } else {
      const newSelected = newIds.map((id) => ({ value: String(id), label: String(id) }))
      setSelectedFamilias(newSelected)
    }
  }

  const visibleFields = useMemo(() => {
    return selectedFields
      .map((k) => fields.find((f) => f.key === k))
      .filter(Boolean) as FieldOption[]
  }, [selectedFields, fields])

  const settings: Handsontable.GridSettings = {
    data:
      tab === 'vendas'
        ? dadosVendasAPI
        : tab === 'estoque'
          ? dadosEstoqueAPI
          : tab === 'cobertura'
            ? dadosCoberturaAPI
            : tab === 'cobertura_clientes'
              ? dadosCoberturaClientesAPI
              : tab === 'apresentacao'
                ? dadosApresentacaoAPI
                : dadosInvalidosAPI,
    colHeaders: visibleFields.map((f) => f.label),
    columns: visibleFields.map((f) => ({ data: f.key, type: 'text', width: 160 })),
    stretchH: 'all',
    height: 'calc(100vh - 100px)',
    rowHeaders: true,
    manualColumnResize: true,
    manualColumnMove: true,
    licenseKey: 'non-commercial-and-evaluation',
  }

  const exportXLSX = () => {
    if (startDate === '' || endDate === '') {
      toast.warn('Você deve preencher o período.')
      return
    }

    const wb = XLSX.utils.book_new()
    const dadosAtuais = (settings.data as any[]) || []

    const nomeAba =
      tab === 'vendas'
        ? 'Vendas Detalhado'
        : tab === 'estoque'
          ? 'Estoque Detalhado'
          : tab === 'cobertura'
            ? 'Cobertura Consolidada'
            : tab === 'cobertura_clientes'
              ? 'Cobertura Distribuidor'
              : 'Produtos Inválidos'

    const cols = visibleFields
    const headers = cols.map((c) => ({ label: c.label, key: c.key }))
    const rows = dadosAtuais.map((row: any) => cols.map((c) => row[c.key] ?? ''))

    const sheet1 = buildCorporateSheet({
      reportTitle: `Relatório de ${nomeAba}`,
      periodLabel: `${formatDateBr(startDate)} até ${formatDateBr(endDate)}`,
      distributorLabel: nomeDistribuidor,
      headers,
      data: rows,
    })
    XLSX.utils.book_append_sheet(wb, sheet1, nomeAba)

    if (tab === 'vendas') {
      const resumo: Record<string, any> = {
        Vendas: { qnt: 0, qnt_cx: 0, valor: 0, clientes: new Set() },
        Devoluções: { qnt: 0, qnt_cx: 0, valor: 0, clientes: new Set() },
        Bonificações: { qnt: 0, qnt_cx: 0, valor: 0, clientes: new Set() },
        Transferências: { qnt: 0, qnt_cx: 0, valor: 0, clientes: new Set() },
      }
      const clientesFiltradosTotalGeral = new Set()

      dadosVendasAPI.forEach((s) => {
        const q = s._raw_qnt || 0
        const cx = s._raw_qnt_cx || 0
        const v = s._raw_valor_dist || 0

        const cliId = String(s.cnpj_cpf_pdv || '').trim()
        if (cliId) clientesFiltradosTotalGeral.add(cliId)

        let chave = ''
        const tipoVendaNorm = String(s.tipo_venda || '')
          .trim()
          .toUpperCase()
        if (tipoVendaNorm === 'N') {
          chave = q < 0 ? 'Devoluções' : 'Vendas'
        } else if (tipoVendaNorm === 'B') chave = 'Bonificações'
        else if (tipoVendaNorm === 'T') chave = 'Transferências'
        else chave = 'Outros'

        if (chave !== 'Outros' && resumo[chave]) {
          resumo[chave].qnt += q
          resumo[chave].qnt_cx += cx
          resumo[chave].valor += v
          if (cliId) resumo[chave].clientes.add(cliId)
        }
      })

      const rowsResumo = Object.entries(resumo).map(([tipo, data]) => [
        tipo,
        data.clientes.size,
        data.qnt,
        data.qnt_cx,
        data.valor,
      ])
      const totalGeralResumo = [
        'TOTAL GERAL',
        clientesFiltradosTotalGeral.size,
        Object.values(resumo).reduce((acc, curr) => acc + curr.qnt, 0),
        Object.values(resumo).reduce((acc, curr) => acc + curr.qnt_cx, 0),
        Object.values(resumo).reduce((acc, curr) => acc + curr.valor, 0),
      ]
      const headersResumo = [
        { label: 'Tipo de Operação', align: 'left' as const },
        { label: 'Cobertura (PDVs)', align: 'right' as const },
        { label: 'Qtd Unidades', align: 'right' as const },
        { label: 'Qtd Caixas', align: 'right' as const },
        { label: 'Valor Total (R$)', align: 'right' as const },
      ]
      const sheet2 = buildCorporateSheet({
        reportTitle: 'Resumo Consolidado de Operações (Sellout)',
        periodLabel: `${formatDateBr(startDate)} até ${formatDateBr(endDate)}`,
        distributorLabel: nomeDistribuidor,
        headers: headersResumo,
        data: rowsResumo,
        totalsRow: totalGeralResumo,
      })
      XLSX.utils.book_append_sheet(wb, sheet2, 'Resumo Geral')
    }

    const nomeArquivo = `Relatorio_${tab}_${nomeDistribuidor.replace(/[^a-zA-Z0-9]/g, '_')}_${startDate}_ate_${endDate}.xlsx`
    XLSX.writeFile(wb, nomeArquivo)
  }

  return (
    <>
      {loading && tab === 'apresentacao' && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 24, 66, 0.95)',
          zIndex: 999999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(5px)'
        }}>
          <Spinner />
          <h2 style={{ color: '#fff', marginTop: '20px', fontFamily: 'Montserrat, sans-serif' }}>Gerando Apresentação...</h2>
          <p style={{ color: '#ccc', fontFamily: 'Montserrat, sans-serif' }}>Por favor aguarde enquanto preparamos o PowerPoint.</p>
        </div>
      )}
      <Content>
      <div className='container'>
        <Right className='ht-theme-main' style={tab === 'semanal_temp' ? { flex: 1, borderRadius: '17px' } : {}}>
          <div
            style={{ padding: '15px 20px', background: '#002b80', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', display: 'flex', gap: '8px', flexWrap: 'wrap' }}
          >
            <TabButton active={tab === 'vendas'} onClick={() => setTab('vendas')}>
              Vendas
            </TabButton>
            <TabButton active={tab === 'estoque'} onClick={() => setTab('estoque')}>
              Estoque
            </TabButton>
            <TabButton active={tab === 'cobertura'} onClick={() => setTab('cobertura')}>
              Cobertura Mix
            </TabButton>
            <TabButton
              active={tab === 'cobertura_clientes'}
              onClick={() => setTab('cobertura_clientes')}
            >
              Cobertura por Cliente
            </TabButton>
            <TabButton active={tab === 'invalidos'} onClick={() => setTab('invalidos')}>
              Produtos Inválidos
            </TabButton>
            <TabButton active={tab === 'apresentacao'} onClick={() => setTab('apresentacao')}>
              Apresentação
            </TabButton>
            <TabButton active={tab === 'semanal_temp'} onClick={() => setTab('semanal_temp')}>
              Fechamento Semanal (Híbrido)
            </TabButton>
          </div>

          {loading ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
              }}
            >
              <Spinner />
              <p style={{ color: '#f8fafc', fontWeight: 'bold', fontSize: '18px', margin: 0 }}>
                {tab === 'apresentacao' ? 'Gerando Apresentação...' : 'Carregando os dados...'}
              </p>
            </div>
          ) : tab === 'semanal_temp' ? (
            <div style={{ height: 'calc(100% - 65px)', overflowY: 'auto' }}>
              <AbaRelatorioSemanalTemp distribuidores={distribuidores} />
            </div>
          ) : tab === 'apresentacao' ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                color: '#f8fafc',
              }}
            >
              {loading && <Spinner />}
              <p style={{ fontWeight: 'bold', fontSize: '18px', margin: 0, marginTop: loading ? '15px' : '0' }}>
                {(!startDate || !endDate) ? 'Insira o período' :
                 loading ? 'Gerando apresentação...' :
                 apresentacaoGerada ? 'Apresentação gerada' :
                 'Disponível para gerar apresentação'}
              </p>
            </div>
          ) : (settings.data?.length ?? 0) === 0 ? (
            <p
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                color: '#f8fafc',
              }}
            >
              Nenhum dado encontrado ou clique em "Buscar Relatório".
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <HotTable ref={hotRef} settings={settings} />
            </div>
          )}
        </Right>

        {tab !== 'semanal_temp' && (
          <LeftContent>
          <h4>Distribuidor</h4>
          <button
            type='button'
            onClick={() => setShowDistModal(true)}
            style={{
              width: '100%',
              minHeight: '48px',
              padding: '10px 14px',
              borderRadius: '14px',
              backgroundColor: '#001842',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textAlign: 'left',
              fontFamily: 'inherit',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#3b82f6')}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)')}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
              <FaBuilding size={16} color={selectedDistribuidores.length > 0 && !selectedDistribuidores.some((d) => d.value === 'todos' || d.value === '__NONE__') ? '#38bdf8' : '#94a3b8'} />
              <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#ffffff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedDistribuidores.length === 0 || selectedDistribuidores.some((d) => d.value === 'todos')
                    ? 'Todos os Distribuidores'
                    : selectedDistribuidores.some((d) => d.value === '__NONE__')
                      ? 'Nenhum Distribuidor'
                      : selectedDistribuidores.length === 1
                        ? String(selectedDistribuidores[0].label || '').split(' - ')[0]
                        : `${selectedDistribuidores.length} Distribuidores Selecionados`}
                </span>
                <span style={{ fontSize: '11px', color: '#94a3b8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedDistribuidores.length === 0 || selectedDistribuidores.some((d) => d.value === 'todos')
                    ? 'Clique para selecionar específicos'
                    : selectedDistribuidores.some((d) => d.value === '__NONE__')
                      ? 'Clique para selecionar'
                      : selectedDistribuidores.map((d) => String(d.label).split(' - ')[0]).join(', ')}
                </span>
              </div>
            </div>
            <div style={{
              backgroundColor: selectedDistribuidores.length > 0 && !selectedDistribuidores.some((d) => d.value === 'todos' || d.value === '__NONE__') ? '#2563eb' : 'rgba(255, 255, 255, 0.1)',
              color: '#ffffff',
              borderRadius: '8px',
              padding: '3px 8px',
              fontSize: '11px',
              fontWeight: 'bold',
              flexShrink: 0,
            }}>
              {selectedDistribuidores.length === 0 || selectedDistribuidores.some((d) => d.value === 'todos')
                ? 'TODOS'
                : selectedDistribuidores.some((d) => d.value === '__NONE__')
                  ? '0'
                  : selectedDistribuidores.length}
            </div>
          </button>
          <hr />

          <h4>Marca</h4>
          <button
            type='button'
            onClick={() => setShowMarcaModal(true)}
            style={{
              width: '100%',
              minHeight: '48px',
              padding: '10px 14px',
              borderRadius: '14px',
              backgroundColor: '#001842',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textAlign: 'left',
              fontFamily: 'inherit',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#3b82f6')}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)')}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
              <FaTag size={16} color={selectedMarcas.length > 0 && !selectedMarcas.some((m) => m.value === 'todas' || m.value === '__NONE__') ? '#38bdf8' : '#94a3b8'} />
              <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#ffffff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedMarcas.length === 0 || selectedMarcas.some((m) => m.value === 'todas')
                    ? 'Todas as Marcas'
                    : selectedMarcas.some((m) => m.value === '__NONE__')
                      ? 'Nenhuma Marca'
                      : selectedMarcas.length === 1
                        ? selectedMarcas[0].label
                        : `${selectedMarcas.length} Marcas Selecionadas`}
                </span>
                <span style={{ fontSize: '11px', color: '#94a3b8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedMarcas.length === 0 || selectedMarcas.some((m) => m.value === 'todas')
                    ? 'Clique para selecionar específicas'
                    : selectedMarcas.some((m) => m.value === '__NONE__')
                      ? 'Clique para selecionar'
                      : selectedMarcas.map((m) => m.label).join(', ')}
                </span>
              </div>
            </div>
            <div style={{
              backgroundColor: selectedMarcas.length > 0 && !selectedMarcas.some((m) => m.value === 'todas' || m.value === '__NONE__') ? '#2563eb' : 'rgba(255, 255, 255, 0.1)',
              color: '#ffffff',
              borderRadius: '8px',
              padding: '3px 8px',
              fontSize: '11px',
              fontWeight: 'bold',
              flexShrink: 0,
            }}>
              {selectedMarcas.length === 0 || selectedMarcas.some((m) => m.value === 'todas')
                ? 'TODAS'
                : selectedMarcas.some((m) => m.value === '__NONE__')
                  ? '0'
                  : selectedMarcas.length}
            </div>
          </button>
          <hr />

          <h4>Família</h4>
          <button
            type='button'
            onClick={() => setShowFamiliaModal(true)}
            style={{
              width: '100%',
              minHeight: '48px',
              padding: '10px 14px',
              borderRadius: '14px',
              backgroundColor: '#001842',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              color: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textAlign: 'left',
              fontFamily: 'inherit',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = '#3b82f6')}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)')}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
              <FaBoxes size={16} color={selectedFamilias.length > 0 && !selectedFamilias.some((f) => f.value === 'todas' || f.value === '__NONE__') ? '#38bdf8' : '#94a3b8'} />
              <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#ffffff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedFamilias.length === 0 || selectedFamilias.some((f) => f.value === 'todas')
                    ? 'Todas as Famílias'
                    : selectedFamilias.some((f) => f.value === '__NONE__')
                      ? 'Nenhuma Família'
                      : selectedFamilias.length === 1
                        ? selectedFamilias[0].label
                        : `${selectedFamilias.length} Famílias Selecionadas`}
                </span>
                <span style={{ fontSize: '11px', color: '#94a3b8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {selectedFamilias.length === 0 || selectedFamilias.some((f) => f.value === 'todas')
                    ? 'Clique para selecionar específicas'
                    : selectedFamilias.some((f) => f.value === '__NONE__')
                      ? 'Clique para selecionar'
                      : selectedFamilias.map((f) => f.label).join(', ')}
                </span>
              </div>
            </div>
            <div style={{
              backgroundColor: selectedFamilias.length > 0 && !selectedFamilias.some((f) => f.value === 'todas' || f.value === '__NONE__') ? '#2563eb' : 'rgba(255, 255, 255, 0.1)',
              color: '#ffffff',
              borderRadius: '8px',
              padding: '3px 8px',
              fontSize: '11px',
              fontWeight: 'bold',
              flexShrink: 0,
            }}>
              {selectedFamilias.length === 0 || selectedFamilias.some((f) => f.value === 'todas')
                ? 'TODAS'
                : selectedFamilias.some((f) => f.value === '__NONE__')
                  ? '0'
                  : selectedFamilias.length}
            </div>
          </button>
          <hr />
          <h4>Período {tab === 'estoque' ? '(Data Ref)' : '(Venda)'}</h4>
          <div
            style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}
          >
            <div style={{ flex: 1 }}>
              <Label>Data Inicial</Label>

              <DateInput
                type='date'
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>

            <div style={{ flex: 1 }}>
              <Label>Data Final</Label>

              <DateInput type='date' value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            </div>
          </div>

          <div style={{ marginTop: '15px' }}>
            <Button
              disabled={loading}
              style={{
                height: 50,
                width: '100%',
                background: loading ? 'rgba(255, 255, 255, 0.1)' : '#3b82f6',
              }}
              onClick={carregarRelatorio}
            >
              {loading ? (tab === 'apresentacao' ? 'Gerando...' : 'Buscando...') : (tab === 'apresentacao' ? 'Gerar Apresentação' : `Buscar Relatório ${tab.replace('_', ' ')}`)}
            </Button>
          </div>
          <hr />

          {tab !== 'apresentacao' && (
            <>
              <h4>Campos (Arraste para Reordenar)</h4>

              <Select
                placeholder='Adicionar campo'
                options={fields
                  .filter((f) => !selectedFields.includes(f.key))
                  .map((f) => ({ value: f.key, label: f.label }))}
                onChange={(opt: any) => {
                  if (!opt) return
                  const key = opt.value
                  const newList = [...selectedFields, key]
                  setSelectedFields(newList)
                  setFields((prev) =>
                    prev.map((f) => ({
                      ...f,
                      visible: newList.includes(f.key),
                    })),
                  )
                }}
                menuPlacement='auto'
                isClearable
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                  control: (base) => ({
                    ...base,
                    minHeight: 50,
                    borderRadius: 20,
                    backgroundColor: '#001842',
                    borderColor: 'rgba(255,255,255,0.1)',
                  }),
                  singleValue: (base) => ({ ...base, color: '#f8fafc' }),
                  input: (base) => ({ ...base, color: '#f8fafc' }),
                  menu: (base) => ({ ...base, borderRadius: 8, fontFamily: 'Montserrat', backgroundColor: '#001842' }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? '#002b80' : 'transparent',
                    color: '#f8fafc',
                    cursor: 'pointer'
                  })
                }}
              />

              <CamposOrdenaveis
                selectedFields={selectedFields}
                setSelectedFields={setSelectedFields}
                fields={fields}
              />
            </>
          )}

          {tab !== 'apresentacao' && (
            <div
              style={{
                position: 'sticky',
                bottom: -20,
                zIndex: 99,
                marginTop: 'auto',
                width: 'calc(100% + 40px)',
                marginLeft: -20,
                padding: '20px',
                background: 'linear-gradient(to top, rgba(0,43,128,1) 50%, rgba(0,43,128,0))',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Button
                disabled={(settings.data?.length ?? 0) === 0}
                style={{
                  height: 50,
                  background: `${(settings.data?.length ?? 0) === 0 ? 'rgba(255, 255, 255, 0.1)' : '#3b82f6'}`,
                }}
                onClick={exportXLSX}
              >
                Exporta dados
              </Button>
            </div>
          )}
        </LeftContent>
        )}
      </div>
    </Content>

    <SelectionModal
      isOpen={showDistModal}
      title='Selecionar Distribuidores'
      icon={<FaBuilding size={20} color='#38bdf8' />}
      items={distItems}
      selectedIds={selectedDistIds}
      onConfirm={handleConfirmDistribuidores}
      onClose={() => setShowDistModal(false)}
      allLabel='Todos os Distribuidores'
    />

    <SelectionModal
      isOpen={showMarcaModal}
      title='Selecionar Marcas'
      icon={<FaTag size={20} color='#38bdf8' />}
      items={marcaItems}
      selectedIds={selectedMarcaIds}
      onConfirm={handleConfirmMarcas}
      onClose={() => setShowMarcaModal(false)}
      allLabel='Todas as Marcas'
    />

    <SelectionModal
      isOpen={showFamiliaModal}
      title='Selecionar Famílias de Produtos'
      icon={<FaBoxes size={20} color='#38bdf8' />}
      items={familiaItems}
      selectedIds={selectedFamiliaIds}
      onConfirm={handleConfirmFamilias}
      onClose={() => setShowFamiliaModal(false)}
      allLabel='Todas as Famílias'
    />
    </>
  )
}
